import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { fields, fieldsReady } from "../constants";
import { useAirportsPageHeading } from "../ContactUs.hook";

export const AirportsPageHeading = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const { data: cameraData, error, isLoading, isError, refetch: useRefetchBrand } = useAirportsPageHeading();
  const {
    data: cameraDataById,
    isLoading: isLoadingCam,
    refetch: refetchBrand,
  } = useDocumentDetails(query?.get("id") || "");
  const [fieldData, setFieldData] = useState<any>();

  async function fetchData() {
    await fieldsReady;

    setFieldData(fields);
  }

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (!query.get("id")) {
      useRefetchBrand();
    }
  }, []);

  useEffect(() => {
    if (query.get("id")) {
      refetchBrand();
    }
  }, [query.get("id")]);

  const MediaFormConfig: FormConfig = {
    initialValues: {
      field_page_banner_image: cameraDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_page_banner_image.png",
              status: "done",
              url: cameraDataById?.payload?.field_page_banner_image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_news_images.png",
              status: "done",
              url: cameraData?.[0]?.field_page_banner_image,
            },
          ]),
      field_page_metadata_image: cameraDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_page_metadata_image.png",
              status: "done",
              url: cameraDataById?.payload?.field_page_metadata_image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_page_metadata_image.png",
              status: "done",
              url: cameraData?.[0]?.field_page_metadata_image,
            },
          ]),
      field_page_title_en: cameraDataById?.payload
        ? decodeHTML(cameraDataById?.payload?.field_page_title_en)
        : decodeHTML(cameraData?.[0]?.field_page_title_en),
      field_page_title_ms: cameraDataById?.payload
        ? decodeHTML(cameraDataById?.payload?.field_page_title_ms)
        : decodeHTML(cameraData?.[0]?.field_page_title_ms),
      field_page_title_zh: cameraDataById?.payload
        ? decodeHTML(cameraDataById?.payload?.field_page_title_zh)
        : decodeHTML(cameraData?.[0]?.field_page_title_zh),
      field_page_description_en: cameraDataById?.payload
        ? decodeHTML(cameraDataById?.payload?.field_page_description_en)
        : decodeHTML(cameraData?.[0]?.field_page_description_en),
      field_page_description_ms: cameraDataById?.payload
        ? decodeHTML(cameraDataById?.payload?.field_page_description_ms)
        : decodeHTML(cameraData?.[0]?.field_page_description_ms),
      field_page_description_zh: cameraDataById?.payload
        ? decodeHTML(cameraDataById?.payload?.field_page_description_zh)
        : decodeHTML(cameraData?.[0]?.field_page_description_zh),
      field_page_metadata_title_en: cameraDataById?.payload
        ? decodeHTML(cameraDataById?.payload?.field_page_metadata_title_en)
        : decodeHTML(cameraData?.[0]?.field_page_metadata_title_en),
      field_page_metadata_title_ms: cameraDataById?.payload
        ? decodeHTML(cameraDataById?.payload?.field_page_metadata_title_ms)
        : decodeHTML(cameraData?.[0]?.field_page_metadata_title_ms),
      field_page_metadata_title_zh: cameraDataById?.payload
        ? decodeHTML(cameraDataById?.payload?.field_page_metadata_title_zh)
        : decodeHTML(cameraData?.[0]?.field_page_metadata_title_zh),
      field_page_metadata_desc_en: cameraDataById?.payload
        ? decodeHTML(cameraDataById?.payload?.field_page_metadata_desc_en)
        : decodeHTML(cameraData?.[0]?.field_page_metadata_desc_en),
      field_page_metadata_desc_ms: cameraDataById?.payload
        ? decodeHTML(cameraDataById?.payload?.field_page_metadata_desc_ms)
        : decodeHTML(cameraData?.[0]?.field_page_metadata_desc_ms),
      field_page_metadata_desc_zh: cameraDataById?.payload
        ? decodeHTML(cameraDataById?.payload?.field_page_metadata_desc_zh)
        : decodeHTML(cameraData?.[0]?.field_page_metadata_desc_zh),
    },
    fields: fieldData?.airportsPageHeading,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    let imageKeys: any = ["field_page_banner_image", "field_page_metadata_image"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    // let descKeys: any = [
    //   "field_page_metadata_desc_zh",
    //   "field_page_metadata_desc_ms",
    //   "field_page_metadata_desc_en",
    //   "field_page_description_zh",
    //   "field_page_description_ms",
    //   "field_page_description_en",
    // ];
    // for (const key of descKeys) {
    //   try {
    //     data[key] = {
    //       value: data[key] || "",
    //       format: "full_html",
    //     };
    //   } catch (error) {}
    // }

    const payload = {
      action: action,
      method: method,
      module: "Contact Us",
      subModule: `${query?.get("activeTab")}_${query.get("subActiveTab")}`,
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      moduleKey: "MAHB_CORPORATE_Contact Us_Airports",
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        id: cameraData?.[0]?.id || cameraDataById?.payload?.id,
        ...data,
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={isLoading || isLoadingCam}
        config={MediaFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${corporateHost}/api/page-header/${cameraData?.[0]?.id || cameraDataById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Contact Us"
      />
    </>
  );
};
